
















































































































































































































import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { mixins } from 'vue-class-component'

// Models
import BeaconModel from '@/_models/BeaconModel'
import BeaconAdjust from '@/components/beacon/partials/BeaconAdjust.vue'

// Shared
import SearchFloor from '@/components/shared/SearchFloor.vue'
import SearchUser from '@/components/shared/SearchUser.vue'
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'

// DumpsComponent
import BeaconUpsertForm from './partials/BeaconUpsertForm.vue'
import SearchSanID from '@/components/shared/SearchSanID.vue'

// Common
import NotFound from '@/components/common/NotFound.vue'

// Mixins
import BeaconListMixin from '@/components/mixins/BeaconListMixin.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

import * as DownloadCsv from 'vue-json-csv'
import { Filter } from '@/_utils/filter'
import { Constant } from '@/_services/constant'

@Component({
  components: {
    SearchUser,
    SearchFloor,
    BeaconAdjust,
    DownloadCsv,
    FilterDropdown,
    NotFound,
    TablePagination,
    BeaconUpsertForm,
    SearchSanID,
  },
  computed: {
    ...mapGetters('beacons', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('beacons', {
      canDelete: 'canDelete',
    }),
  },
})
export default class BeaconList extends mixins(BeaconListMixin, TableSortMixin) {
  // data
  beaconType: string = Constant.BEACON_TYPE_STATIC
  filterUtilPage: any = new Filter('filter_beaconlist_page')
  filterUtilTableSort: any = new Filter('filter_beacon_list_table_sort')

  isSearchFloorActive: boolean = false
  isBeaconAdjustActive: boolean = false
  isSearchSanIDActive: boolean = false

  isSingleAdjustBeacon: boolean = false

  name: any = ''

  get manageFeature() {
    return this.authen?.currentUser?.manage_features
  }

  get upsertModalWidth() {
    return !!this.manageFeature.ip_camera ? '75vw' : '500px'
  }

  get authen() {
    return this.$store.state.authentication
  }

  get exportCSVName(): string {
    return 'beacons.csv'
  }

  get selectedFloor(): object {
    return {
      _id: this.selected.floor_id,
      name: this.selected.floor_name,
    }
  }

  get filteredData(): BeaconModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.beacons) {
      return []
    }

    return this.beacons.filter((item: BeaconModel): boolean => {
      const searchKey =
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1 ||
        item._id === this.pageFilters.searchQuery // Can search by uuid

      return searchKey
    })
  }

  get selectedSanID(): object {
    return {
      san_id: this.selected.san_id,
    }
  }

  // Overide BeaconListMixin mixin
  getAllBeacons() {
    this.$store.dispatch('beacons/getAll', {
      beacon_type: Constant.BEACON_TYPE_STATIC,
    })
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)

    this.csvFields = ['_id', 'beacon_uuid', 'location_name', 'major', 'minor', 'lat', 'lon', 'floor_id', 'floor_name']
  }

  handleOpenModelAdjustMap(isSingle: boolean = false): void {
    this.isSingleAdjustBeacon = isSingle
    this.isBeaconAdjustActive = true
  }

  handleSelectedFloorDone(data): void {
    this.selected.floor_id = data._id
    this.selected.floor_name = data.name
    this.isSearchFloorActive = false
  }

  beaconAdjustDone(data: any = {}): void {
    if (this.isSingleAdjustBeacon) {
      this.selected.lat = data.lat
      this.selected.lon = data.lon
      this.selected.floor_id = data.floor_id
      this.selected.floor_name = data.floor_name
    } else {
      this.getAllBeacons()
    }

    this.isBeaconAdjustActive = false
  }

  selectedSanIDDone(data): void {
    this.selected.san_id = data.san_id
    this.isSearchSanIDActive = false
  }
}
